<script>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fancyapps/ui/dist/panzoom/panzoom.css';
import '@fancyapps/ui/dist/carousel/carousel.css';

export default {
  name: 'ProductFancybox', // Updated component name for multi-word rule
  props: {
    options: {
      type: Object,
      default: () => ({}), // Default to an empty object if no options are passed
    },
  },
  mounted() {
    this.initFancybox();
  },
  updated() {
    this.rebindFancybox();
  },
  beforeUnmount() {
    Fancybox.destroy();
  },
  methods: {
    initFancybox() {
      Fancybox.bind(this.$refs.container, '[data-fancybox]', {
        Carousel: {
          infinite: true,
        },
        Thumbs: {
          showOnStart: false,
        },
        contentClick: 'iterateZoom',
        Images: {
          zoom: true,
          Panzoom: {
            panMode: 'drag',
            maxScale: 1.25,
          },
        },
        Toolbar: {
          display: {
            left: ['infobar'],
            right: ['prev', 'close', 'next'],
          },
        },
        ...(this.options || {}),
      });
    },
    rebindFancybox() {
      Fancybox.unbind(this.$refs.container);
      Fancybox.close();
      this.initFancybox();
    },
  },
};
</script>

<template>
  <div ref="container">
    <slot />
  </div>
</template>
